export const GET_ALL_MEMBERS_REQUEST = 'GET_ALL_MEMBERS_REQUEST';
export const GET_ALL_MEMBERS_SUCCESS = 'GET_ALL_MEMBERS_SUCCESS';
export const GET_ALL_MEMBERS_FAILURE = 'GET_ALL_MEMBERS_FAILURE';
export const GET_ONE_MEMBER_SUCCESS = 'GET_ONE_MEMBER_SUCCESS';

export const GET_ALL_PICTURES_REQUEST = 'GET_ALL_PICTURES_REQUEST';
export const GET_ALL_PICTURES_SUCCESS = 'GET_ALL_PICTURES_SUCCESS';
export const GET_ALL_PICTURES_FAILURE = 'GET_ALL_PICTURES_FAILURE';

export const GET_ALL_NEWS_REQUEST = 'GET_ALL_NEWS_REQUEST';
export const GET_ALL_NEWS_SUCCESS = 'GET_ALL_NEWS_SUCCESS';
export const GET_ALL_NEWS_FAILURE = 'GET_ALL_NEWS_FAILURE';

export const GET_ALL_PROJECTS_REQUEST = 'GET_ALL_PROJECTS_REQUEST';
export const GET_ALL_PROJECTS_SUCCESS = 'GET_ALL_PROJECTS_SUCCESS';
export const GET_ALL_PROJECTS_FAILURE = 'GET_ALL_PROJECTS_FAILURE';

export const GET_ALL_COLLABORATORS_REQUEST = 'GET_ALL_COLLABORATORS_REQUEST';
export const GET_ALL_COLLABORATORS_SUCCESS = 'GET_ALL_COLLABORATORS_SUCCESS';
export const GET_ALL_COLLABORATORS_FAILURE = 'GET_ALL_COLLABORATORS_FAILURE';

export const GET_ALL_PUBLICATIONS_REQUEST = 'GET_ALL_PUBLICATIONS_REQUEST';
export const GET_ALL_PUBLICATIONS_SUCCESS = 'GET_ALL_PUBLICATIONS_SUCCESS';
export const GET_ALL_PUBLICATIONS_FAILURE = 'GET_ALL_PUBLICATIONS_FAILURE';
export const GET_PUBLICATIONS_BY_YEAR_SUCCESS =
	'GET_PUBLICATIONS_BY_YEAR_SUCCESS';

export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
